// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce366717","732":"0a055d9b"}[chunkId] + ".chunk.js";
};